const currencySymbol: Record<string, string> = {
  USD: "$",
  EUR: "€",
};

/**
 * Safely get a currency display symbol for the given currency code.
 * Returns the mapped symbol if found, otherwise falls back to the code itself or empty string.
 */
export function getCurrencyDisplay(currency: string | null | undefined): string {
  if (!currency) return "";
  return currencySymbol[currency] || currency;
}

export default currencySymbol;

/**
 * Formats an amount using the active interface language.
 *
 * Several cards previously mixed `toLocaleString("en-US", …)` with bare
 * `toFixed(2)`, so `12,345.00 €` sat directly above `1234.56 €`, and the
 * hardcoded `en-US` ignored the Spanish locale entirely.
 */
export function formatAmount(value: number | null | undefined, locale: string, decimals = 2): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "---";
  return value.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

/** Signed amount; `+` only above zero, so a flat result is not shown as a gain. */
export function formatSignedAmount(value: number | null | undefined, locale: string, decimals = 2): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return "---";
  const sign = value > 0 ? "+" : value < 0 ? "-" : "";
  return `${sign}${formatAmount(Math.abs(value), locale, decimals)}`;
}
